import { API_AP } from "../../constants";

export const GET_USER_LOGIN_ENDPOINT = API_AP;